<!-- <div class="modal-dialog modal-dialog-centered detail-modal"> -->
    <div>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Update Zone Detail</h4>
            <button type="button" class="btn-close" aria-label="Close"
            (click)="reset()" (keydown.enter)="$event.preventDefault()"></button>
        </div>
        <div class="modal-body">
            <div class="card" >
                <div class="card-body">
                <form [formGroup]="modelZoneForm">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="product" class="form-label">Product</label>
                                <ng-select id="product" formControlName="ddlProduct" placeholder="Select"
                                    [items]="productList" bindLabel="name" [bindValue]="'code'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false">
                                    <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                        <span>{{ item.name }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="formVendor" class="form-label">Vendor</label>
                                <ng-select id="formVendor" formControlName="ddlVendor" placeholder="Select"
                                    [items]="vendorList" bindLabel="name" [bindValue]="'code'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false" [openOnEnter]="false"
                                    (change)="getAllVendorServices($event.id, true)">
                                    <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                        <span>{{ item.name }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="zone" class="form-label">Zone</label>
                                <ng-select id="zone" formControlName="ddlZone" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="zoneList" bindLabel="zonecode" [bindValue]="'zonecode'" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="service" class="form-label">Service</label>
                                <ng-select id="service" formControlName="ddlService" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="serviceList" bindLabel="servicename" [bindValue]="'servicename'">
                                    <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                        <span>{{ item.servicename }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                            <div class="card-header bg-transparent border-bottom text-uppercase">Origin</div>
                        
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="country" class="form-label">Country</label>
                                    <ng-select id="country" formControlName="ddlOriginCountry" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                        [items]="countryList" bindLabel="name" [bindValue]="'code'"
                                        (change)="onOriginCountryChange()" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="state" class="form-label">State</label>
                                    <ng-select id="state" formControlName="ddlOriginState" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                        [items]="originStateList" bindLabel="name" [bindValue]="'code'"
                                        (change)="onOriginStateChange()" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="city" class="form-label">City</label>
                                    <ng-select id="city" formControlName="ddlOriginCity" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                        [items]="originCityList" bindLabel="name" [bindValue]="'code'" />
                                </div>
                            </div>
                        
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label for="originPincode" class="form-label">Pincode </label>
                            <div class="input-group mb-6">
                                <span class="input-group-text group-label-sm">From</span>
                                <input type="number" class="form-control form-control-sm"
                                    formControlName="txtOriginFromPincode" >
                                <span class="input-group-text group-label-sm">To</span>
                                <input type="number" class="form-control form-control-sm"
                                    formControlName="txtOriginToPincode" >
                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="card-header bg-transparent border-bottom text-uppercase">Destination</div>
                    
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="country" class="form-label">Country</label>
                                <ng-select id="country" formControlName="ddlDestinationCountry" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    placeholder="Select" [items]="countryList" bindLabel="name"
                                    [bindValue]="'code'" (change)="onDestinationCountryChange()" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="state" class="form-label">State</label>
                                <ng-select id="state" formControlName="ddlDestinationState" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="destinationStateList" bindLabel="name" [bindValue]="'code'"
                                    (change)="onDestinationStateChange()" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="city" class="form-label">City</label>
                                <ng-select id="city" formControlName="ddlDestinationCity" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="destinationCityList" bindLabel="name" [bindValue]="'code'" />
                            </div>
                        </div>
                      
                        <div class="row">
                            <div class="col-md-6">
                                <label for="destinationPincode" class="form-label">Pincode </label>
                                <div class="input-group mb-6">
                                    <span class="input-group-text group-label-sm">From</span>
                                    <input type="number" class="form-control form-control-sm"
                                        formControlName="txtDestinationFromPincode" >
                                    <span class="input-group-text group-label-sm">To</span>
                                    <input type="number" class="form-control form-control-sm"
                                        formControlName="txtDestinationToPincode" >
                                </div>
                            </div>
        
                        </div>
                    </div>
                </form>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" data-dismiss="modal"  (click)="updateZoneDetails()" (keydown.enter)="updateZoneDetails()">Save</button>
        </div>
      </div>
    </div>